import OrderStatus from './OrderStatus'

export default OrderStatus
